var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"r-notice-detail height-full"},[_c('c-read-editor',{attrs:{"title":_vm.notice.ggbt,"attach":_vm.attachList,"content":_vm.notice.ggnr,"abs":_vm.notice.noticeAbs}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }